/**
 * Navegación a /agenda con el mismo comportamiento que al elegir un resultado
 * del buscador en AgendaGeneral (agenda + fecha + hora + resaltar cita).
 */
export const AGENDA_FOCUS_STORAGE_KEY = 'smile_agenda_ir_a_cita';

/** Guarda el foco en sessionStorage y navega a /agenda (misma lógica que el buscador en AgendaGeneral). */
export function saveAgendaFocusAndNavigate(history, payload) {
    if (!payload.agendaId || !payload.fechaCita) return;
    const body = {
        agenda_id: String(payload.agendaId),
        agenda_nombre: payload.agendaNombre || '',
        fecha_cita: String(payload.fechaCita),
        hora_cita: payload.horaCita ? String(payload.horaCita) : '',
        id_cita:
            payload.citaId != null && payload.citaId !== ''
                ? String(payload.citaId)
                : ''
    };
    try {
        sessionStorage.setItem(AGENDA_FOCUS_STORAGE_KEY, JSON.stringify(body));
    } catch (e) {
        return;
    }
    const pid = encodeURIComponent(String(payload.agendaId));
    history.push(`/agenda?profesional=${pid}`);
}
